module.exports = __webpack_public_path__ + "static/media/custom-checkbox-1-unchecked.f95e36f7.svg";